import React from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';

import { FormItem, FormLabel, FormControl, FormField } from '@/components/v2/Form/Form';
import { Textarea } from '@/components/v2/Form/TextArea';

interface AnnouncementsTextAreaProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
}

export const AnnouncementsTextArea = <T extends FieldValues>({
  control,
  name,
}: AnnouncementsTextAreaProps<T>) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem>
        <FormLabel>Announcements</FormLabel>
        <FormControl>
          <Textarea
            data-cy="announcements-textarea"
            rows={11}
            placeholder="Enter announcements"
            className="resize-none"
            {...field}
          />
        </FormControl>
      </FormItem>
    )}
  />
);
